import { render, staticRenderFns } from "./ConfigDowntimesList.vue?vue&type=template&id=9c03233e&scoped=true&"
import script from "./ConfigDowntimesList.vue?vue&type=script&lang=js&"
export * from "./ConfigDowntimesList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDowntimesList.vue?vue&type=style&index=0&id=9c03233e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c03233e",
  null
  
)

export default component.exports